import { render, staticRenderFns } from "./Tanimlamalar.vue?vue&type=template&id=cfbf22ee&scoped=true&"
import script from "./Tanimlamalar.vue?vue&type=script&lang=js&"
export * from "./Tanimlamalar.vue?vue&type=script&lang=js&"
import style0 from "./Tanimlamalar.vue?vue&type=style&index=0&id=cfbf22ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbf22ee",
  null
  
)

export default component.exports